import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentLang } from '../../store/selectors/language.selectors';
import { SyrianLocationService } from '../../services/syrian-location.service';

// Impure so a language change invalidates Angular's pipe cache even when city is unchanged.
// The memoized result avoids normalization/transliteration during ordinary change detection.
@Pipe({ name: 'syrianCity', standalone: true, pure: false })
export class SyrianCityPipe implements PipeTransform {
  private readonly language = inject(Store).selectSignal(selectCurrentLang);
  private readonly locations = inject(SyrianLocationService);
  private city?: string | null;
  private lang?: string;
  private result = '';
  transform(value: string | null | undefined): string {
    const language = this.language();
    if (value !== this.city || language !== this.lang) {
      this.city = value;
      this.lang = language;
      this.result = this.locations.display(value, language);
    }
    return this.result;
  }
}
